import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/** `localStorage`, or nothing while the landing is prerendered — Node has no storage. */
@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly storage = isPlatformBrowser(inject(PLATFORM_ID)) ? localStorage : null;

  list(): (string | null)[] {
    const result: (string | null)[] = [];
    const storage = this.storage;
    if (!storage) return result;

    for (let i = 0; i < storage.length; i++) {
      if (storage.key(i)) {
        result.push(storage.key(i));
      }
    }
    return result;
  }

  get(key: string): string | null {
    return this.storage?.getItem(key) ?? null;
  }

  set(key: string, value: string): void {
    this.storage?.removeItem(key);
    this.storage?.setItem(key, value);
  }

  remove(key: string) {
    this.storage?.removeItem(key);
  }

  clear() {
    this.storage?.clear();
  }
}
